import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] text-accent-600">EXPLORE</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            分类快捷入口
          </h2>
        </div>
        <p className="text-sm text-foreground-500 max-w-md">
          从历史到社会动态，五个核心领域带你系统化地走进黑人文化的多维图景。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {categories.map((cat, i) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`group relative rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer h-56 ${
              i === 0 ? "sm:col-span-2 lg:col-span-1" : ""
            }`}
          >
            <img
              src={cat.cover}
              alt={cat.name}
              title={`${cat.name}分类 - 黑人文化资讯`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent" />
            <div className="relative z-10 h-full flex flex-col justify-end p-4">
              <span className="w-9 h-9 rounded-md bg-background-50/15 backdrop-blur text-background-50 flex items-center justify-center mb-3">
                <i className={`${cat.icon} text-lg`} />
              </span>
              <h3 className="font-heading text-lg font-semibold text-background-50">{cat.name}</h3>
              <p className="text-[11px] tracking-widest text-background-300 mt-0.5">{cat.en}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}